import { Component, OnDestroy, OnInit } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { Subject, takeUntil } from 'rxjs';
import { RecentlyAddedProjectsDataService } from '../../data-access/widgets/recently-added-projects-data.service';

@Component({
  selector: 'app-recently-added-projects-widget',
  template: `
    <app-dashboard-card title="Recently Added Projects">
      <div *ngIf="loading">Loading projects...</div>
      <div *ngIf="!loading && error" class="error">{{ error }}</div>
      <div *ngIf="!loading && !error && items.length === 0">No projects</div>
      <mat-list *ngIf="!loading && !error && items.length > 0" class="dashboard-scroll-list">
        <mat-list-item class="dashboard-scroll-list-item" *ngFor="let item of items; trackBy: trackByProject" (click)="selectProject(item)">{{ item.projectName || item.name }}</mat-list-item>
      </mat-list>
    </app-dashboard-card>
  `,
  styles: [
    `.dashboard-scroll-list { display: block; max-height: 280px; overflow-y: auto; background: var(--table-row-bg); border-radius: 6px; }`,
    `.dashboard-scroll-list-item { min-height: 36px; cursor: pointer; color: var(--table-heading); }`,
    `.dashboard-scroll-list-item:nth-child(odd) { background: var(--table-row-bg); }`,
    `.dashboard-scroll-list-item:nth-child(even) { background: var(--table-row-alternate-bg); }`,
    `.dashboard-scroll-list-item:hover { background: var(--table-row-hover); }`,
    `@media (max-width: 768px) { .dashboard-scroll-list { max-height: 220px; } }`
  ]
})
export class RecentlyAddedProjectsWidgetComponent implements OnInit, OnDestroy {
  items: any[] = [];
  loading = false;
  error = '';
  private readonly destroy$ = new Subject<void>();

  constructor(
    private readonly dataService: RecentlyAddedProjectsDataService,
    private readonly stateService: StateService
  ) { }

  ngOnInit(): void {
    this.loading = true;
    this.error = '';
    this.dataService.getProjects()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: items => this.items = Array.isArray(items) ? items : [],
        error: () => {
          this.error = 'Unable to load projects';
          this.items = [];
        },
        complete: () => this.loading = false
      });
  }

  selectProject(item: any): void {
    const projectId = String(item?.projectID || '').trim();
    if (!projectId) {
      return;
    }

    const projectName = String(item?.projectName || item?.name || '').trim();
    this.stateService.go('search.project', {
      projectID: projectId,
      projectName: encodeURIComponent(projectName)
    });
  }

  trackByProject(_: number, item: any): string {
    return String(item?.projectID || item?.id || item?.projectName || '');
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
